// @flow
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import type { User } from '../../types';
import firebase from '../../services/firebase';
import Spinner from '../ui/Spinner';
import SyncTargets from '../SyncTargets';
import Login from '../Login';
import LoggedInContainer from './containers/LoggedInContainer';
import theme from './theme';


const useStyles = makeStyles({
    spinner: {
        position: 'fixed'
    }
});

export type Props = $ReadOnly<{
    userInitialized: boolean,
    isLoggedIn: boolean,

    setUser: (user: null | User) => void
}>;

function App({ userInitialized, isLoggedIn, setUser }: Props) {
    const classes = useStyles();

    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
            user = user ? user.toJSON() : null;

            if(!user) {
                setUser(null);
            }
            else {
                const currentUser = firebase.auth().currentUser;

                if(currentUser) {
                    currentUser.getIdTokenResult()
                        .then((idTokenResult) => {
                            if (idTokenResult.claims && idTokenResult.claims.admin) {
                                setUser({
                                    uid: user.uid,
                                    email: user.email,
                                    name: user.displayName
                                });
                            } else {
                                setUser(null);
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                }
                else {
                    setUser(null);
                }
            }
        }, function(error) {
            console.error(error);
        });
    }, [setUser]);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <SyncTargets />

            <Spinner isLoading={!userInitialized} spinnerClassName={classes.spinner}>
                {userInitialized &&
                    <React.Fragment>
                        {isLoggedIn ?
                            <LoggedInContainer />
                            :
                            <Login />
                        }
                    </React.Fragment>
                }
            </Spinner>
        </ThemeProvider>
    );
}

export default App;